import { AnyAction } from 'redux';
import { HttpRequestError } from '../../types';

import { SynchroFilterRequest, ExecuteSynchroRequest } from '../../services/SynchroApi';
import { SynchroLogItem } from '../../components/SynchroDataGrid/handlerFactory';

export const FIND_SYNCHRO_HISTORY_REQUESTED = 'FIND_SYNCHRO_HISTORY_REQUESTED';
export const FIND_SYNCHRO_HISTORY_SUCCEEDED = 'FIND_SYNCHRO_HISTORY_SUCCEEDED';
export const FIND_SYNCHRO_HISTORY_FAILED = 'FIND_SYNCHRO_HISTORY_FAILED';

export const EXECUTE_SYNCHRO_REQUESTED = 'EXECUTE_SYNCHRO_REQUESTED';
export const EXECUTE_SYNCHRO_SUCCEEDED = 'EXECUTE_SYNCHRO_SUCCEEDED';
export const EXECUTE_SYNCHRO_FAILED = 'EXECUTE_SYNCHRO_FAILED';
export const FIND_SYNCHRO_ONEDRIVE_REQUESTED = 'FIND_SYNCHRO_ONEDRIVE_REQUESTED';

export interface State {
  data: SynchroLogItem[];
  loading: boolean;
  executionLoading: boolean;
  error: HttpRequestError | null;
}

export interface FindSynchroHistoryRequestedAction {
  type: typeof FIND_SYNCHRO_HISTORY_REQUESTED;
  payload: SynchroFilterRequest;
  sendToOndrive: boolean;
}

export interface FindSynchroHistorySucceededAction extends AnyAction {
  type: typeof FIND_SYNCHRO_HISTORY_SUCCEEDED;
  payload: SynchroLogItem[];
}

export interface FindSynchroHistoryFailedAction extends AnyAction {
  type: typeof FIND_SYNCHRO_HISTORY_FAILED;
  payload: HttpRequestError;
}

export interface ExecuteSynchroRequestedAction extends AnyAction {
  type: typeof EXECUTE_SYNCHRO_REQUESTED;
  payload: ExecuteSynchroRequest;
}

export interface ExecuteSynchroSucceededAction extends AnyAction {
  type: typeof EXECUTE_SYNCHRO_SUCCEEDED;
}

export interface ExecuteSynchroFailedAction extends AnyAction {
  type: typeof EXECUTE_SYNCHRO_FAILED;
  payload: HttpRequestError;
}

export type SynchroActionTypes =
  | FindSynchroHistoryRequestedAction
  | FindSynchroHistorySucceededAction
  | FindSynchroHistoryFailedAction
  | ExecuteSynchroRequestedAction
  | ExecuteSynchroSucceededAction
  | ExecuteSynchroFailedAction;
